import { ApolloCache } from '@apollo/client';

import { TemplatesWithReportsQuery, TemplatesWithReportsQueryVariables } from '../../../types';
import { TEMPLATES_WITH_REPORTS } from '../../templateWithReports';
import { TemplateReport } from '../../types';

type Props = {
  cache: ApolloCache<unknown>;
  organizationId: string;
  report: TemplateReport;
};

export const onUpdateReport = ({ cache, organizationId, report }: Props): void => {
  const existingData = cache.readQuery<TemplatesWithReportsQuery, TemplatesWithReportsQueryVariables>({
    query: TEMPLATES_WITH_REPORTS,
    variables: {
      orgId: organizationId,
    },
  });

  if (!existingData?.templatesWithReports) return;
  const newData = existingData.templatesWithReports.map((template) => {
    if (template.id !== report.templateId) return template;

    const newReports = template.reports.map((newReport) => {
      if (newReport.id !== report.id) return newReport;

      return {
        ...report,
        filters: report.filters,
      };
    });

    return {
      ...template,
      reports: newReports,
    };
  });

  cache.writeQuery<TemplatesWithReportsQuery, TemplatesWithReportsQueryVariables>({
    query: TEMPLATES_WITH_REPORTS,
    variables: {
      orgId: organizationId,
    },
    data: {
      templatesWithReports: newData || [],
    },
    overwrite: true,
  });
};
